// extracted by mini-css-extract-plugin
export default {"tree":"wfF9XkdkhIO1jMMgWNDq","parent":"K_x465cDF7Pr_z7Q57Hp"};